/**
 * Data flows: canary hits on sink events → `source → sink (origin)` records
 * (docs/event-model.md §6).
 */
import type { CanaryRegistry, DataFlow } from "../canary";
import { type AuditEvent, CANARY_ENCODINGS, CANARY_HIT_FIELDS } from "../events";
import { originOf } from "../url";

/** One flow per (canary, sink event), in event order, then registry order. */
export function deriveFlows(events: readonly AuditEvent[], registry: CanaryRegistry): DataFlow[] {
  const flows: DataFlow[] = [];
  for (const event of events) {
    if (!event.canaries?.length) continue;
    const origin = event.network ? originOf(event.network.url) : "null";
    for (const canary of registry.canaries) {
      const hits = event.canaries.filter((h) => h.canary === canary.id);
      if (hits.length === 0) continue;
      flows.push({
        canary: canary.id,
        source: canary.source,
        kind: canary.kind,
        seq: event.seq,
        sink: event.target,
        ...(origin !== "null" && { origin }),
        encodings: CANARY_ENCODINGS.filter((e) => hits.some((h) => h.encoding === e)),
        fields: CANARY_HIT_FIELDS.filter((f) => hits.some((h) => h.field === f)),
        partial: hits.every((h) => h.partial === true),
      });
    }
  }
  return flows;
}
